/**
 * Mobile nav drawer: predictive search, A–Z brand index, Shop by Vehicle panel.
 */
(function () {
  'use strict';

  function handleFetchErrors(response) {
    if (!response.ok) {
      return response.json().then(function (json) {
        var e = new Error(response.statusText);
        e.json = json;
        throw e;
      });
    }
    return response;
  }

  function getSizedImageUrl(src, size) {
    if (typeof window.getSizedImageUrl === 'function') {
      return window.getSizedImageUrl(src, size);
    }
    return src;
  }

  function initDrawerSearch(drawer) {
    var input = drawer.querySelector('[data-drawer-search-input]');
    var form = drawer.querySelector('[data-drawer-search-form]');
    var searchRoot = drawer.querySelector('[data-drawer-search]');
    var closeBtn = drawer.querySelector('[data-drawer-search-close]');
    var resultsWrap = drawer.querySelector('[data-drawer-search-results-wrapper]');
    var productsUl = drawer.querySelector('[data-drawer-search-results]');
    var pagination = drawer.querySelector('[data-drawer-search-pagination]');
    var viewAll = pagination && pagination.querySelector('[data-drawer-search-view-all]');
    var productTplEl = document.querySelector('[drawer-product-grid-item-template]');
    var noresultTplEl = document.querySelector('[drawer-noresult-template]');

    if (!input || !productsUl || !productTplEl || !window.theme || !window.PaloAlto || !window.Sqrl) {
      return;
    }

    var productTemplate = productTplEl.innerHTML;
    var noresultTemplate = noresultTplEl.innerHTML;
    var debounceTimer;
    var lastTerms = '';
    var searchSeq = 0;
    var docListenerAttached = false;

    function setLoading(on) {
      if (on) {
        drawer.classList.add('drawer-search--is-loading');
      } else {
        drawer.classList.remove('drawer-search--is-loading');
      }
    }

    function onDocumentPointerDown(e) {
      if (!resultsWrap || resultsWrap.hidden) return;
      if (searchRoot && searchRoot.contains(e.target)) return;
      reset(false);
    }

    function attachDocListener() {
      if (docListenerAttached) return;
      document.addEventListener('pointerdown', onDocumentPointerDown, true);
      docListenerAttached = true;
    }

    function detachDocListener() {
      if (!docListenerAttached) return;
      document.removeEventListener('pointerdown', onDocumentPointerDown, true);
      docListenerAttached = false;
    }

    function reset(clearInput) {
      searchSeq++;
      productsUl.innerHTML = '';
      if (resultsWrap) resultsWrap.hidden = true;
      if (pagination) pagination.hidden = true;
      if (closeBtn) closeBtn.hidden = true;
      if (clearInput) input.value = '';
      detachDocListener();
      setLoading(false);
    }

    function renderNoResult() {
      return Sqrl.render(noresultTemplate, { item: { text: theme.strings.no_results } });
    }

    function renderProduct(product) {
      var stripHtmlRegex = /(<([^>]+)>)/gi;
      var title = product.title.replace(stripHtmlRegex, '');
      var media = product.media && product.media[0];
      var image;

      if (media) {
        var layout = false;
        if (theme.settings.gridImageSize === 'contain') {
          layout = media.preview_image.aspect_ratio > theme.settings.gridImageAspectRatio ? 'landscape' : 'portrait';
        }
        image = {
          thumb: PaloAlto.BgSet.render(getSizedImageUrl(media.preview_image.src, '2048x'), media.preview_image.aspect_ratio),
          aspectRatio: media.preview_image.aspect_ratio,
          layout: layout,
        };
      } else {
        image = {
          thumb: theme.assets.no_image,
          alt: '',
          aspectRatio: 1,
        };
      }

      return Sqrl.render(productTemplate, {
        product: Object.assign({}, product, {
          title: title,
          image: image,
        }),
      });
    }

    function fetchProducts(products) {
      if (!products || !products.length) {
        return Promise.resolve(renderNoResult());
      }
      var promises = products.map(function (product) {
        return PaloAlto.fetchProduct(product.handle).then(function (productJSON) {
          if (!productJSON) return '';
          var formatted = PaloAlto.formatPrices(productJSON);
          return renderProduct(formatted);
        });
      });
      return Promise.all(promises).then(function (parts) {
        return parts.join('');
      });
    }

    function runSearch(terms) {
      if (!terms || terms.length < 2) {
        reset(false);
        return;
      }
      lastTerms = terms;
      var mySeq = ++searchSeq;
      productsUl.innerHTML = '';
      setLoading(true);
      if (resultsWrap) resultsWrap.hidden = false;
      if (closeBtn) closeBtn.hidden = false;
      attachDocListener();

      fetch(
        '/search/suggest.json?q=' +
          encodeURIComponent(terms) +
          '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last'
      )
        .then(handleFetchErrors)
        .then(function (r) {
          return r.json();
        })
        .then(function (response) {
          if (mySeq !== searchSeq) return;
          var result = response.resources && response.resources.results;
          var products = result && result.products ? result.products : [];
          return fetchProducts(products).then(function (html) {
            if (mySeq !== searchSeq) return;
            productsUl.innerHTML = html;
            if (pagination && viewAll) {
              if (products.length > 9) {
                viewAll.href =
                  theme.routes.search_url +
                  '?type=product&q=' +
                  encodeURIComponent(terms) +
                  '&options[prefix]=last';
                pagination.hidden = false;
              } else {
                pagination.hidden = true;
              }
            }
          });
        })
        .catch(function (e) {
          if (mySeq !== searchSeq) return;
          console.error(e);
          productsUl.innerHTML = renderNoResult();
        })
        .finally(function () {
          if (mySeq !== searchSeq) return;
          setLoading(false);
        });
    }

    input.addEventListener('input', function (e) {
      var val = e.target.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        runSearch(val);
      }, 300);
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = input.value.trim();
        if (val.length > 1) {
          window.location.href =
            theme.routes.search_url + '?type=product&q=' + encodeURIComponent(val) + '&options[prefix]=last';
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        reset(false);
      });
    }
  }

  function sortKeys(keys) {
    return keys.sort(function (a, b) {
      if (a === '#') return 1;
      if (b === '#') return -1;
      return a.localeCompare(b);
    });
  }

  /** First A–Z letter in the name, skipping leading digits and symbols (e.g. "123Hobby" → "H"). */
  function getVendorLetterKey(name) {
    var s = String(name || '').trim();
    for (var i = 0; i < s.length; i++) {
      var ch = s.charAt(i);
      if (/[A-Za-z]/.test(ch)) {
        return ch.toUpperCase();
      }
    }
    return null;
  }

  function loadBrandAzData() {
    var dataEl = document.getElementById('nav-drawer-brand-vendors');
    if (!dataEl) return null;

    var raw;
    try {
      raw = JSON.parse(dataEl.textContent);
    } catch (err) {
      return null;
    }

    if (!Array.isArray(raw)) {
      return null;
    }

    var seen = new Set();
    var vendors = [];
    raw.forEach(function (row) {
      if (row == null) return;
      if (typeof row === 'string') {
        var n = String(row).trim();
        if (n && !seen.has(n)) {
          seen.add(n);
          vendors.push({ name: n, url: '' });
        }
        return;
      }
      var name = String(row.name || '').trim();
      if (!name || seen.has(name)) return;
      seen.add(name);
      vendors.push({
        name: name,
        url: typeof row.url === 'string' ? row.url : '',
      });
    });

    vendors.sort(function (a, b) {
      return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    });

    var groups = {};
    vendors.forEach(function (item) {
      var key = getVendorLetterKey(item.name);
      if (!key) {
        key = '#';
      }
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });

    var keys = sortKeys(Object.keys(groups));
    if (!keys.length) return null;
    return { groups: groups, keys: keys };
  }

  function vendorCollectionUrl(vendorName, root) {
    return root + 'collections/all?filter.p.vendor=' + encodeURIComponent(vendorName);
  }

  /** Build A–Z letter list into the inline collapsible dropdown (not the stacked panel). */
  function initBrandAzDropdownMount(drawer) {
    var mount = drawer.querySelector('[data-brand-az-mount]');
    var brandData = loadBrandAzData();
    if (!mount || !brandData || !brandData.keys.length) return;

    mount.innerHTML = '';
    var wrap = document.createElement('div');
    wrap.className = 'mobile-nav__brand-az-dropdown';
    var ul = document.createElement('ul');
    ul.className = 'mobile-nav__brand-az-dropdown-list mobile-nav__sub-sublist';
    brandData.keys.forEach(function (letter) {
      var li = document.createElement('li');
      li.className = 'mobile-nav__brand-az-dropdown-item mobile-menu__item mobile-menu__item--level-3';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mobile-nav__brand-az-letter mobile-navlink--level-3';
      btn.dataset.brandAzLetter = letter;
      btn.setAttribute('aria-label', letter);

      var text = document.createElement('span');
      text.className = 'mobile-nav__brand-az-letter-text';
      text.textContent = letter;
      btn.appendChild(text);

      var arrow = document.createElement('span');
      arrow.className = 'mobile-nav__trigger-arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M0.246012 9.84603C-0.0820289 10.1741 -0.0820289 10.7059 0.246012 11.034C0.574052 11.362 1.10591 11.362 1.43395 11.034L6.23395 6.23397C6.56199 5.90593 6.56199 5.37407 6.23395 5.04603L1.43395 0.24603C1.10591 -0.0820101 0.574052 -0.0820101 0.246012 0.24603C-0.0820289 0.574071 -0.0820289 1.10593 0.246012 1.43397L4.45434 5.6423L0.246012 9.84603Z" fill="black"/>' +
        '</svg>';
      btn.appendChild(arrow);

      li.appendChild(btn);
      ul.appendChild(li);
    });
    wrap.appendChild(ul);
    mount.appendChild(wrap);
  }

  function initNavDrawerPanels(drawer) {
    var stackEl = drawer.querySelector('[data-mobile-nav-panel-stack]');
    var backBtn = drawer.querySelector('[data-mobile-nav-panel-back]');
    var titleEl = drawer.querySelector('[data-mobile-nav-panel-title]');
    var bodyEl = drawer.querySelector('[data-mobile-nav-panel-body]');
    var navRoot = drawer.querySelector('[data-mobile-nav-root]');
    var navBody = drawer.querySelector('.drawer__nav-body');
    if (!stackEl || !backBtn || !titleEl || !bodyEl) return;

    var panelStack = [];

    initBrandAzDropdownMount(drawer);

    var brandData = loadBrandAzData();

    function urlRoot() {
      var root = window.theme && theme.routes && theme.routes.root ? theme.routes.root : '/';
      if (root.length && root[root.length - 1] !== '/') {
        root += '/';
      }
      return root;
    }

    // Brand-letter clicks (and other deep-panel pushes) can fire while a plain
    // accordion item (e.g. "A-Z Brand Index") is still expanded in the normal
    // drawer tree. That accordion state never gets cleared on its own, so its
    // content stays visible underneath/behind the new full-panel overlay,
    // rendering as an overlapping mess. Collapse any open accordions the
    // moment we hand off to the panel-stack overlay.
    function collapseOpenAccordions() {
      drawer.querySelectorAll('.is-expanded').forEach(function (el) {
        el.classList.remove('is-expanded');
        if (el.hasAttribute('aria-expanded')) {
          el.setAttribute('aria-expanded', 'false');
        }
        if (el.classList.contains('mobile-dropdown')) {
          el.setAttribute('hidden', 'true');
          el.setAttribute('aria-hidden', 'true');
          el.style.height = '';
        }
      });
    }

    function showStackChrome() {
      collapseOpenAccordions();
      drawer.classList.add('drawer--nav-panel-open');
      stackEl.hidden = false;
      stackEl.setAttribute('aria-hidden', 'false');
      drawer.scrollTop = 0;
      if (navBody) navBody.scrollTop = 0;
      stackEl.scrollTop = 0;
      requestAnimationFrame(function () {
        stackEl.classList.add('is-active');
      });
    }

    function hideStackChrome() {
      drawer.classList.remove('drawer--nav-panel-open');
      stackEl.classList.remove('is-active');
      setTimeout(function () {
        stackEl.hidden = true;
        stackEl.setAttribute('aria-hidden', 'true');
        bodyEl.innerHTML = '';
        titleEl.textContent = '';
        panelStack = [];
        if (navRoot) navRoot.setAttribute('aria-hidden', 'false');
      }, 260);
    }

    function renderTop() {
      var item = panelStack[panelStack.length - 1];
      if (!item) return;
      titleEl.textContent = item.title;
      bodyEl.innerHTML = '';
      bodyEl.appendChild(item.node);
      if (navRoot) navRoot.setAttribute('aria-hidden', 'true');
      stackEl.scrollTop = 0;
      bodyEl.scrollTop = 0;
    }

    function pushPanel(title, node) {
      panelStack.push({ title: title, node: node });
      if (panelStack.length === 1) showStackChrome();
      renderTop();
    }

    function popPanel() {
      panelStack.pop();
      if (panelStack.length === 0) {
        hideStackChrome();
      } else {
        renderTop();
      }
    }

    backBtn.addEventListener('click', function () {
      popPanel();
    });

    drawer.querySelectorAll('.mobile-menu__item--deep-panel').forEach(function (li) {
      var source = li.querySelector('[data-deep-panel-source]');
      var titleLink = li.querySelector('.mobile-navlink--level-2');
      var trigger = li.querySelector('[data-deep-panel-trigger]');
      var link = li.querySelector('[data-deep-panel-link]');
      if (!source || !titleLink) return;

      function openDeep() {
        var t = titleLink.textContent.trim();
        var clone = source.cloneNode(true);
        clone.removeAttribute('data-deep-panel-source');
        pushPanel(t, clone);
      }

      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openDeep();
        });
      }
      if (link) {
        link.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            openDeep();
          },
          true
        );
      }
    });

    if (brandData && brandData.keys.length) {
      var root = urlRoot();

      drawer.addEventListener(
        'click',
        function (e) {
          var letterBtn = e.target.closest('[data-brand-az-letter]');
          if (!letterBtn || !drawer.contains(letterBtn)) return;
          e.preventDefault();
          e.stopPropagation();
          var letter = letterBtn.getAttribute('data-brand-az-letter');
          var list = brandData.groups[letter];
          if (!list || !list.length) return;

          var ul = document.createElement('ul');
          ul.className = 'mobile-nav__sub-sublist mobile-nav-panel__sublist';
          list.forEach(function (item) {
            var href = item.url;
            if (!href) {
              href = vendorCollectionUrl(item.name, root);
            }
            var vli = document.createElement('li');
            vli.className = 'mobile-menu__item mobile-menu__item--level-3';
            var a = document.createElement('a');
            a.className = 'mobile-navlink mobile-navlink--level-3';
            a.href = href;
            a.textContent = item.name;
            vli.appendChild(a);
            ul.appendChild(vli);
          });
          pushPanel(letter, ul);
        },
        true
      );
    }
  }

  function clearChildren(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function initDesktopBrandAz() {
    var mounts = document.querySelectorAll('[data-desktop-brand-az-mount]');
    if (!mounts.length) return;

    var brandData = loadBrandAzData();
    if (!brandData || !brandData.keys.length) return;

    var root = window.theme && theme.routes && theme.routes.root ? theme.routes.root : '/';
    if (root.length && root[root.length - 1] !== '/') root += '/';

    mounts.forEach(function (mount) {
      if (mount.dataset.desktopBrandAzReady === '1') return;
      mount.dataset.desktopBrandAzReady = '1';
      clearChildren(mount);

      var lettersRow = document.createElement('div');
      lettersRow.className = 'desktop-nav__brand-az-letters';

      var vendorsPanel = document.createElement('div');
      vendorsPanel.className = 'desktop-nav__brand-az-vendors';

      var letterButtons = {};

      function renderVendors(letter) {
        clearChildren(vendorsPanel);
        var list = brandData.groups[letter];
        if (!list || !list.length) return;
        var ul = document.createElement('ul');
        ul.className = 'desktop-nav__brand-az-vendor-list';
        list.forEach(function (item) {
          var href = item.url || vendorCollectionUrl(item.name, root);
          var li = document.createElement('li');
          li.className = 'desktop-nav__brand-az-vendor-item';
          var a = document.createElement('a');
          a.className = 'desktop-nav__brand-az-vendor-link';
          a.href = href;
          a.textContent = item.name;
          li.appendChild(a);
          ul.appendChild(li);
        });
        vendorsPanel.appendChild(ul);
      }

      function setActive(letter) {
        Object.keys(letterButtons).forEach(function (k) {
          letterButtons[k].classList.toggle('is-active', k === letter);
        });
        renderVendors(letter);
      }

      brandData.keys.forEach(function (letter) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'desktop-nav__brand-az-letter';
        btn.dataset.letter = letter;
        btn.textContent = letter;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          setActive(letter);
        });
        letterButtons[letter] = btn;
        lettersRow.appendChild(btn);
      });

      mount.appendChild(lettersRow);
      mount.appendChild(vendorsPanel);

      var defaultLetter = letterButtons['A'] ? 'A' : brandData.keys[0];
      setActive(defaultLetter);
    });
  }

  function onReady() {
    var drawer = document.getElementById('nav-drawer');
    if (drawer) {
      initDrawerSearch(drawer);
      initNavDrawerPanels(drawer);
    }
    initDesktopBrandAz();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
